function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import FilterIcon from '@material-ui/icons/FilterList';
import Tooltip from '@material-ui/core/Tooltip';
import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import { LocaleContext } from '@tecsinapse/ui-kit';
import Drawer from '@material-ui/core/Drawer';
import Container from './Container/Container';

var onApplyFilter = function onApplyFilter(setFilters, setOpen) {
  return function (advancedFilters) {
    setFilters(function (prevFilters) {
      return _objectSpread(_objectSpread({}, prevFilters), {}, {
        advancedFilters: advancedFilters,
        page: 0,
        startIndex: 0,
        stopIndex: prevFilters.rowsPerPage - 1
      });
    });
    setOpen(false);
  };
};

var Transition = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Slide, _extends({
    direction: "up",
    ref: ref
  }, props));
});

var AdvancedFilters = function AdvancedFilters(_ref) {
  var advancedFilters = _ref.advancedFilters,
      setFilters = _ref.setFilters,
      filters = _ref.filters,
      mobile = _ref.mobile,
      customAdvancedFilters = _ref.customAdvancedFilters,
      onDrawerClose = _ref.onDrawerClose;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  var _useContext = useContext(LocaleContext),
      tooltipAdvancedFilter = _useContext.Table.tooltipAdvancedFilter;

  if (!advancedFilters && !customAdvancedFilters) {
    return null;
  }

  var _advancedFilters$maxH = advancedFilters.maxHeight,
      maxHeight = _advancedFilters$maxH === void 0 ? '100%' : _advancedFilters$maxH,
      _advancedFilters$maxW = advancedFilters.maxWidth,
      maxWidth = _advancedFilters$maxW === void 0 ? mobile ? '1000' : '350px' : _advancedFilters$maxW;
  var maxSizeAdvancedFilters = {
    maxHeight: maxHeight,
    maxWidth: maxWidth
  };

  var handleOpenFilters = function handleOpenFilters() {
    setOpen(true);
  };

  var handleClose = function handleClose() {
    onDrawerClose(); // eslint-disable-line

    setOpen(false);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tooltip, {
    title: tooltipAdvancedFilter
  }, (customAdvancedFilters === null || customAdvancedFilters === void 0 ? void 0 : customAdvancedFilters.toolbarButton) ? customAdvancedFilters.toolbarButton(handleOpenFilters) : /*#__PURE__*/React.createElement(IconButton, {
    onClick: handleOpenFilters
  }, /*#__PURE__*/React.createElement(FilterIcon, null))), !mobile ? /*#__PURE__*/React.createElement(Drawer, {
    open: open,
    onClose: handleClose,
    anchor: "right"
  }, /*#__PURE__*/React.createElement("div", {
    style: maxSizeAdvancedFilters
  }, /*#__PURE__*/React.createElement(Container, {
    advancedFilters: advancedFilters,
    onApplyFilter: onApplyFilter(setFilters, setOpen),
    setFilters: setFilters,
    filters: filters,
    customAdvancedFilters: customAdvancedFilters,
    closeDialog: handleClose
  }))) : /*#__PURE__*/React.createElement(Dialog, {
    fullScreen: true,
    open: open,
    onClose: handleClose,
    TransitionComponent: Transition
  }, /*#__PURE__*/React.createElement("div", {
    style: maxSizeAdvancedFilters
  }, /*#__PURE__*/React.createElement(Container, {
    advancedFilters: advancedFilters,
    onApplyFilter: onApplyFilter(setFilters, setOpen),
    setFilters: setFilters,
    filters: filters,
    mobile: mobile,
    closeDialog: handleClose,
    customAdvancedFilters: customAdvancedFilters
  }))));
};

AdvancedFilters.defaultProps = {
  advancedFilters: null
};
AdvancedFilters.propTypes = {
  advancedFilters: PropTypes.shape({
    applyFilters: PropTypes.func,
    filtersGroup: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: PropTypes.string
    })),
    filters: PropTypes.arrayOf(PropTypes.shape({
      group: PropTypes.string,
      type: PropTypes.oneOf(['input', 'select', 'multi-select', 'date', 'time', 'checkbox']).isRequired,
      name: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      options: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.any,
        label: PropTypes.string,
        disabled: PropTypes.bool
      })),
      value: PropTypes.any,
      fullWidth: PropTypes.bool
    }))
  })
};
export default AdvancedFilters;